import useLogPageViews from "./useLogPageViews";

const LogPageViews = () => {
	useLogPageViews();
	return null;
};

export default LogPageViews;
